'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardHostStats(host, total, errors, rate, parcel) {
  this.q9 = null;
  this.rG = 0;
  this.xm = 0;
  this.tR = 0.0;
  this.xn = 0.0;
  this.q9 = host;
  this.rG = total;
  this.xm = errors;
  this.tR = rate;
  this.xn = parcel;
}
export { $c_Lpresto_types$DashboardHostStats as $c_Lpresto_types$DashboardHostStats };
$p = $c_Lpresto_types$DashboardHostStats.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardHostStats;
/** @constructor */
function $h_Lpresto_types$DashboardHostStats() {
}
export { $h_Lpresto_types$DashboardHostStats as $h_Lpresto_types$DashboardHostStats };
$h_Lpresto_types$DashboardHostStats.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardHostStats"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.q9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.rG);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xm);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().gV(this.tR));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().gV(this.xn));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 5);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$DashboardHostStats) && (((((this.rG === x$0.rG) && (this.xm === x$0.xm)) && (this.tR === x$0.tR)) && (this.xn === x$0.xn)) && (this.q9 === x$0.q9))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "DashboardHostStats";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.q9;
      break;
    }
    case 1: {
      return this.rG;
      break;
    }
    case 2: {
      return this.xm;
      break;
    }
    case 3: {
      return this.tR;
      break;
    }
    case 4: {
      return this.xn;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardHostStats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jD)));
}
export { $isArrayOf_Lpresto_types$DashboardHostStats as $isArrayOf_Lpresto_types$DashboardHostStats };
var $d_Lpresto_types$DashboardHostStats = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardHostStats, "presto.types$DashboardHostStats", ({
  jD: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardHostStats as $d_Lpresto_types$DashboardHostStats };
//# sourceMappingURL=presto.types$-Dashboard-Host-Stats.js.map
